import React from 'react';

class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          <p>Jotain meni pieleen.</p>
          <button onClick={() => this.setState({ hasError: false })}>
            Yritä uudelleen
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
